import { render, staticRenderFns } from "./LabItem.vue?vue&type=template&id=865cddde&scoped=true&"
import script from "./LabItem.vue?vue&type=script&lang=js&"
export * from "./LabItem.vue?vue&type=script&lang=js&"
import style0 from "./LabItem.vue?vue&type=style&index=0&id=865cddde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865cddde",
  null
  
)

export default component.exports